import { DownOutlined } from '@ant-design/icons';
import { Col, Dropdown, Input, Menu, Pagination, Row, Spin, Modal } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import ItemProduct from '~/components/ItemProduct';
import { getNumberWithCommas } from '~/utils';
import styles from './NotificationPage.module.scss';
import { useDispatch, useSelector } from 'react-redux';

import notificationAPI from '~/api/NotificationAPI';

import Notification from '~/components/Notification';

import { checkNewNoti } from '~/utils/checkNewNoti';

const cx = classNames.bind(styles);

const NotificationPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';

    const [isShowLogoutModal, setIsShowLogoutModal] = useState(false);
    const onCancel = () => {
        setIsShowLogoutModal(false);
    };
    const handleShowLogOut = () => {
        setIsShowLogoutModal(true);
    };
    const [loading, setIsLoading] = useState(false);
    const [notiList, setNotiList] = useState([]);
    //Dot Noti
    const [isNewNoti, setIsNewNoti] = useState(false);
    const [countUnSeen, setCountUnSeen] = useState(0);
    const [countNoti, setCountNoti] = useState(0);

    const [paginationNoti, setPaginationNoti] = useState({
        page: 1,
        limit: 25,
        total_item: 0,
        total_page: 0,
    });
    const fetchNotification = async (step = null) => {
        setIsLoading(true);
        let newLimit = paginationNoti.limit;
        if (step) {
            newLimit = paginationNoti.limit + step;
        }
        const params = {
            fields: '["$all", {"order":["$all"]}]',
            order: '[["created_at","desc"]]',
            page: paginationNoti.page,
            limit: newLimit,
        };
        try {
            const res = await notificationAPI.getList(params);
            const resArr = res.results?.objects?.rows;
            // const isNotSeen = resArr.some((item) => item.seen === false);
            // setIsNewNoti(isNotSeen);
            setCountUnSeen(res.results?.objects?.countUnSeen);
            setPaginationNoti({
                ...paginationNoti,
                limit: newLimit,
                page: res.pagination.current_page,
                total_item: res.results.objects.count,
                total_page: Math.ceil(res.results.objects.count / paginationNoti.limit),
            });
            setCountNoti(res.results?.objects?.count);

            setNotiList(resArr);
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            // console.log(err);
        }
    };

    const seenAllNoti = async () => {
        setIsLoading(true);
        try {
            const res = await notificationAPI.seenAll();
            setIsLoading(false);
            fetchNotification();
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (isLogin) {
            fetchNotification();
        }
    }, [paginationNoti.page, isLogin]);

    useEffect(() => {
        const newNoti = checkNewNoti(notiList);
        if (!newNoti) {
            setIsNewNoti(newNoti);
        }
    }, [notiList]);

    return (
        <div>
            <div className={cx('title_header')}>
                <Row className={cx('title_header_row')}>
                    <p className={cx('title')}>Notification</p>
                    <p className={cx('btn_seen_all')} onClick={seenAllNoti}>
                        Read them all
                    </p>
                </Row>
            </div>
            <div className={cx('content')}>
                <Notification
                    countNoti={countNoti}
                    loading={loading}
                    notiList={notiList}
                    setNotiList={setNotiList}
                    fetchNotiList={fetchNotification}
                />
            </div>
        </div>
    );
};

export default NotificationPage;
